const actionTypeIdentifier = '3F6D1B42-AC98-4E27-9D2A-81C4E2F9B6F1';

export const getLocationSite = `GET-LOCATION-SITE-${actionTypeIdentifier}`;
export const setLocationSitePageSize = `SET-LOCATION-SITE-PAGE-SIZE-${actionTypeIdentifier}`;
export const setLocationSiteColSearchStr = `SET-LOCATION-SITE-COL-SEARCH-STR-${actionTypeIdentifier}`;
export const sortLocationSite = `SORT-LOCATION-SITE-${actionTypeIdentifier}`;
export const setLocationSiteFilter = `SET-LOCATION-SITE-FILTER-${actionTypeIdentifier}`;
export const applyLocationSiteFilter = `APPLY-LOCATION-SITE-FILTER-${actionTypeIdentifier}`;

